import React, { AnchorHTMLAttributes, ReactNode } from "react";
import useButtonTheme, { ButtonTheme } from "../../hooks/useButtonTheme";

export interface AnchorButtonProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  disabled?: boolean;
  theme?: ButtonTheme;
}

const AnchorButton = ({
  className,
  children,
  disabled,
  theme,
  ...props
}: AnchorButtonProps) => {
  const { text, bg, border } = useButtonTheme(disabled ? "disabled" : theme);

  return (
    <a
      className={`${className} ${text} ${bg} ${border} ${
        disabled ? "cursor-not-allowed" : ""
      } inline-block px-6 py-3 text-xs font-medium text-center uppercase transition-all duration-300`}
      style={{
        minWidth: "170px",
      }}
      {...props}
    >
      {children}
    </a>
  );
};

export default AnchorButton;
